define("shared/components/shared/media-items/media-item-video", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.processing}}
    <img class="o--media" src={{@mediaItem.imageUrl}} />
  {{else}}
    <Shared::Ui::Video @preload="auto" @src={{@mediaItem.videoUrl}} class="o--modal__media" height="640" width="640" />
  {{/if}}
  {{#if @mediaItem.needsApproval}}
    <span class="o--mediaOverlay">
      <span class="img--overlay__pending"></span>
    </span>
  {{/if}}
  */
  {
    "id": "2XBWnmUR",
    "block": "[[[41,[30,0,[\"processing\"]],[[[1,\"  \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,1,[\"imageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,1],[[24,0,\"o--modal__media\"],[24,\"height\",\"640\"],[24,\"width\",\"640\"]],[[\"@preload\",\"@src\"],[\"auto\",[30,1,[\"videoUrl\"]]]],null],[1,\"\\n\"]],[]]],[41,[30,1,[\"needsApproval\"]],[[[1,\"  \"],[10,1],[14,0,\"o--mediaOverlay\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"img--overlay__pending\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@mediaItem\"],false,[\"if\",\"shared/ui/video\"]]",
    "moduleName": "shared/components/shared/media-items/media-item-video.hbs",
    "isStrictMode": false
  });
  class MediaItemVideoComponent extends _component2.default {
    get processing() {
      return this.args.mediaItem.processing;
    }
  }
  _exports.default = MediaItemVideoComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MediaItemVideoComponent);
});